export default "/dist/files/icone_fuseau_horaire.7ea392773f7f57b752fe956716b3e599.svg";